ixModuleRouting("impactx.companyhierarchy", {
    "/companyhierarchy": {
        template: "<ixa-company-hierarchy></ixa-company-hierarchy>",
        templateUrl: "modules/companyhierarchy/templates/company-hierarchy.html",
        controller: "CompanyHierarchyCtrl",
        controllerAs: "companyHierarchyCtrl",
        process: "ViewCompanyHierarchy",
        workspace: "admin",
    },
});
